import React, { RefObject } from 'react';
import { PoseGroup } from 'react-pose';
import { CollapsibleItem } from './styledComponents';

type Props = {
  animationDuration?: number;
  isCollapsed: boolean;
  collapsedRef: RefObject<HTMLDivElement>;
  children: React.ReactNode;
};

const Collapsible = ({
  isCollapsed,
  animationDuration = 500,
  collapsedRef,
  children,
}: Props) => (
  <PoseGroup flipMove={false}>
    {isCollapsed && (
      <CollapsibleItem
        animationDuration={animationDuration}
        ref={collapsedRef}
        key='key'
      >
        {children}
      </CollapsibleItem>
    )}
  </PoseGroup>
);

export default Collapsible;
